import { z } from 'zod';

export const NovelSchema = z.object({
  id: z.string(),
  title: z.string(),
  author: z.string(),
  description: z.string(),
  coverColor: z.string(),
  content: z.string(),
  scraped: z.boolean().optional(),
  publisher: z.string().optional(),
  ncode: z.string().optional(),
  url: z.string().optional(),
  downloadedAt: z.string().optional(),
  lastUpdatedAt: z.string().optional(),
  episodesCount: z.number().optional(),
  type: z.enum(['series', 'short']).optional(),
  genre: z.string().optional(),
  tags: z.array(z.string()).optional(),
  status: z.enum(['ongoing', 'completed', 'short']).optional(),
  charCount: z.number().optional(),
});

export const CustomNovelsArraySchema = z.array(NovelSchema);

export const ReadingHistoryItemSchema = z.object({
  novelId: z.string(),
  sectionIndex: z.number(),
  sectionTitle: z.string(),
  progressPercentage: z.number(),
  updatedAt: z.number(),
});

export const ReadingHistoryRecordSchema = z.record(z.string(), ReadingHistoryItemSchema);

export const NovelCoverConfigSchema = z
  .object({
    bgColor: z.string().optional(),
    bgImage: z.string().optional(),
    titleColor: z.string().optional(),
    titleSize: z.string().optional(),
    titleFont: z.enum(['serif', 'sans', 'lanobe']).optional(),
    authorColor: z.string().optional(),
    authorSize: z.string().optional(),
  })
  .passthrough();

export const CoverConfigsRecordSchema = z.record(z.string(), NovelCoverConfigSchema);

export const ReadingSpeedHistorySchema = z.array(z.number());

export const NovelOrderArraySchema = z.array(z.string());

export const BackupDataSchema = z.object({
  version: z.string(),
  exportedAt: z.string(),
  customNovels: CustomNovelsArraySchema,
  localStorageData: z.record(z.string(), z.string()),
});
